import { CUSTOM_ELEMENTS_SCHEMA, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { UserGridComponent } from '../../components/user/user-grid/user-grid.component';
import { UserSearchTextForm } from '../../form-model/user-search-text.form.model';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CommonModule } from '@angular/common';
import { UserSearchComponent } from '../../components/user/user-search/user-search.component';
import { UserFiltersComponent } from '../../components/user/user-filters/user-filters.component';
import { BehaviorSubject, Subject, debounceTime, takeUntil } from 'rxjs';
import { UserFilterForm } from '../../form-model/user-filter.form.model';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthPolicies } from '../../auth/auth-policies';

@Component({
  selector: 'app-user',
  imports: [UserSearchComponent, UserFiltersComponent, UserGridComponent, NgxSkeletonLoaderModule, ReactiveFormsModule, CommonModule],
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserComponent implements OnInit, OnDestroy {
  filterFormGroup = this.formBuilder.group({
    userSearchTextForm: this.formBuilder.group<UserSearchTextForm>({
      searchText: this.formBuilder.control(null),
      appliedUserSearchTextFilter: this.formBuilder.control(false),
    }),

    userFilterForm: this.formBuilder.group<UserFilterForm>({
      userName: this.formBuilder.control(null),
      email: this.formBuilder.control(null),
      fullName: this.formBuilder.control(null),
      role: this.formBuilder.control([]),
      region: this.formBuilder.control([]),
      cluster: this.formBuilder.control([]),
      shopCode: this.formBuilder.control([]),
      isActive: this.formBuilder.control([]),
      applyUserFilter: this.formBuilder.control(false), // 🔥 CRITICAL
    }),
  });
  // New: active tab index observable (0 = Shop users, 1 = Other users)
  public currentIndex$ = new BehaviorSubject<number>(0);
  pendingTabIndex: number | null = null;
  private readonly tabSwitch$ = new Subject<number>();
  private readonly destroyed$ = new Subject<void>();

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    public readonly authPolicy: AuthPolicies,
  ) {}

  ngOnInit(): void {
    const tab = this.route.snapshot.queryParamMap.get('tab');
    if (tab === 'non-shop-user') {
      this.currentIndex$.next(1);
    } else {
      this.currentIndex$.next(0);
    }

    // Debounce rapid tab clicks: only the last click within 300ms takes effect.
    this.tabSwitch$.pipe(debounceTime(300), takeUntil(this.destroyed$)).subscribe((index) => {
      this.filterFormGroup.controls.userFilterForm.reset({
        userName: null,
        email: null,
        fullName: null,
        role: [],
        region: [],
        cluster: [],
        shopCode: [],
        isActive: [],
        applyUserFilter: false,
      });
      this.filterFormGroup.controls.userSearchTextForm.reset({
        searchText: null,
        appliedUserSearchTextFilter: false,
      });
      this.pendingTabIndex = null;
      this.currentIndex$.next(index);
      this.router.navigate([], {
        queryParams: { tab: index === 0 ? 'shop-user' : 'non-shop-user' },
        queryParamsHandling: 'replace',
      });
    });
  }

  // New: set active tab (called from template)
  setTab(index: number): void {
    this.pendingTabIndex = index;
    this.tabSwitch$.next(index);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  navigateToCreate(): void {
    this.router.navigate(['/users/create']);
  }
}
